
export default {
  name: 'AppPasswordInput',
  model: { event: 'change' },
  props: {
    value: { type: String, default: '' },
    name: { type: String, required: true },
    placeholder: { type: String, required: true },
    invalid: { type: Boolean, default: false },
    autocomplete: { type: String, default: null },
    maxlength: { type: Number, default: null },
    size: {
      type: String,
      default: 'medium',
      validator: v => ['medium', 'large'].includes(v)
    }
  },
  computed: {
    ignore1Password() {
      // https://developer.1password.com/docs/web/compatible-website-design/
      return true;
    }
  }
};
